
const MERCATOR_RADIUS = 85445659.44705395;
const mercadorOffset = 268435456


export const getZoom = (map: mapkit.Map) : number => {
  const longitudeDelta = map.region.span.longitudeDelta;
  const zoomScale = longitudeDelta * MERCATOR_RADIUS * Math.PI / (180.0 * map.element.clientWidth);
  const zoomer = 20 - Math.log2(zoomScale);
  return zoomer < 0 ? 0 : parseFloat((zoomer + 1.0).toFixed(4))
}

// Code belong is kindly borrowed from
// https://medium.com/@xavierletohic/how-to-migrate-from-google-maps-api-javascript-to-apple-mapkit-js-dc862f1f0a89

const longitudeToPixelSpaceX = (longitude: number) : number => {
  return Math.round(mercadorOffset + MERCATOR_RADIUS * longitude * Math.PI / 180.0);
}

const latitudeToPixelSpaceY = (latitude: number) : number =>{
  return Math.round(mercadorOffset - MERCATOR_RADIUS * Math.log((1 + Math.sin(latitude * Math.PI / 180.0)) / (1 - Math.sin(latitude * Math.PI / 180.0))) / 2.0);
}

const pixelSpaceXToLongitude = (pixelX: number) : number => {
  return ((Math.round(pixelX) - mercadorOffset) / MERCATOR_RADIUS) * 180.0 / Math.PI;
}

const pixelSpaceYToLatitude = (pixelY: number) : number => {
  return (Math.PI / 2.0 - 2.0 * Math.atan(Math.exp((Math.round(pixelY) - mercadorOffset) / MERCATOR_RADIUS))) * 180.0 / Math.PI;
}

export const deltaFromZoomLevel = (map: mapkit.Map, centerCoordinates: mapkit.Coordinate, zoomLevel: number) : mapkit.CoordinateSpan => {

  const centerPixelX = longitudeToPixelSpaceX(centerCoordinates.longitude)
  const centerPixelY = latitudeToPixelSpaceY(centerCoordinates.latitude)

  const zoomExponent = 20 - zoomLevel
  const zoomScale = Math.pow(2, zoomExponent)

  const mapSizeInPixels = map.visibleMapRect.size
  const scaledMapWidth = map.element.clientWidth * zoomScale
  const scaledMapHeight = map.element.clientHeight * zoomScale

  const topLeftPixelX = centerPixelX - (scaledMapWidth / 2)
  const topLeftPixelY = centerPixelY - (scaledMapHeight / 2)

  const minLng = pixelSpaceXToLongitude(topLeftPixelX)
  const maxLng = pixelSpaceXToLongitude(topLeftPixelX + scaledMapWidth)
  const longitudeDelta = maxLng - minLng

  const minLat = pixelSpaceYToLatitude(topLeftPixelY)
  const maxLat = pixelSpaceYToLatitude(topLeftPixelY + scaledMapHeight)
  const latitudeDelta = -1 * (maxLat - minLat)

  return new mapkit.CoordinateSpan(latitudeDelta, longitudeDelta)
}